import { createClient, searchRequestFactory } from '@infuse/api/common';

export enum ServerLogEntryType {
  WAMP_RESULT = 'WAMP_RESULT',
  WAMP_CALL = 'WAMP_CALL',
  WAMP_ERROR = 'WAMP_ERROR',
  WAMP_SEND = 'WAMP_SEND',
  WAMP_RESULT_ERROR = 'WAMP_RESULT_ERROR',
  REJECTED_TOKEN = 'REJECTED_TOKEN',
  VALID_TOKEN = 'VALID_TOKEN',
  COMM_ERROR = 'COMM_ERROR',
  WAMP_UNKNOWN = 'WAMP_UNKNOWN'
}

export interface ServerLog {
  id: number;
  sessionId?: string;
  chargingStationId: string;
  callId: string;
  messageType: ServerLogEntryType;
  procUri: string;
  payload: string;
  vendorErrorCode?: string;
  errorCode?: string;
  createdAt: Date;
}

const client = createClient('/rest/serverlog');

export const serverlogPermissions = {
  SEARCH: 'cpms.search-charging-station-ocpp-logs'
};

export const searchServerLogs = searchRequestFactory<ServerLog>(client, {
  permissionId: serverlogPermissions.SEARCH
});
